"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
var NoPages = function NoPages(props) {
  var _a = props,
    className = _a.className,
    _a$size = _a.size,
    size = _a$size === void 0 ? IconSize.Medium : _a$size,
    _a$color = _a.color,
    color = _a$color === void 0 ? "inherit" : _a$color,
    rest = __objRest(_a, ["className", "size", "color"]);
  var iconClass = classNames(styles.icon({
    size: size,
    color: color
  }), "kl-icon", "kl-icon--".concat(size), className);
  return React.createElement("svg", __spreadValues({
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    className: iconClass
  }, rest), /* @__PURE__ */React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0294 22.2578L2.84195 2.07031L1.42773 3.48453L3.04719 5.10398C2.82758 5.52097 2.70328 5.99597 2.70328 6.5V18.5C2.70328 20.1569 4.04642 21.5 5.70328 21.5H19.4432L21.6152 23.672L23.0294 22.2578ZM17.4432 19.5L12.4432 14.5H9.70328V12.5H10.4432L9.44321 11.5H7.70328V9.76007L4.70328 6.76007V18.5C4.70328 19.0523 5.15099 19.5 5.70328 19.5H17.4432ZM13.0822 9.5L15.0822 11.5H17.7033V9.5H13.0822ZM20.7033 6.5V17.1211L22.6497 19.0675C22.6849 18.8837 22.7033 18.694 22.7033 18.5V6.5C22.7033 4.84315 21.3601 3.5 19.7033 3.5H7.08218L9.08218 5.5H19.7033C20.2556 5.5 20.7033 5.94772 20.7033 6.5Z",
    fill: "#8790A6"
  }));
};
export default NoPages;